import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type LWApiPublicNetworkDnsReverseAssignableIpsResultRaw } from '@liquidweb-dev/club-sauce/public/network/dns/reverse/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_DNS_REVERSE_ASSIGNABLE_IPS_QUERY_KEY =
	'/network/dns/reverse/assignableIps';

const useDnsReverseAssignableIps = (
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsReverseAssignableIpsResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [NETWORK_DNS_REVERSE_ASSIGNABLE_IPS_QUERY_KEY],
		queryFn: () => api.network.dns.reverse.apiRaw.assignableIps(),
		...options,
	});

export default useDnsReverseAssignableIps;
